export default class ParallaxScroll {

    constructor() {
        
            this._parallaxScroll()
        
    }
    _parallaxScroll() {
        const e = document.querySelector('.parallax-background');
        if (typeof(e) !== 'undefined'  && e !== null){
            const background = document.querySelector('.parallax-background');
            window.addEventListener('scroll', function(e){
                const scrolled = window.pageYOffset;
                background.style.top = - (scrolled * 0.2) + 'px';
            })
        }
    }
}